import { AnalyticsDirectivesModule } from '@analytics/events';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
  HammerModule,
} from '@angular/platform-browser';
import { BacUsageQuestionnaireModalEffects } from '@innogy/become-a-customer/calculate';
import {
  BaseOrderOverviewComponent,
  OrderContainerComponent,
  OrderOverviewSmeComponent,
} from '@innogy/become-a-customer/order';
import {
  EmailConsentsModalComponent,
  OfferBreakdownComponent,
  OfferBreakdownRowComponent,
  OfferBudgetbillComponent,
  OfferBudgetbillSmeComponent,
  OfferLabelComponent,
  OfferMoreInfoBlockComponent,
  OfferUspsComponent,
  SelectCommodityPipe,
  VerticalOfferModalPlaceholderComponent,
} from '@innogy/become-a-customer/shared';
import { BecomeACustomerStateModule } from '@innogy/become-a-customer/state';
import {
  UsageQuestionnaireContainerComponent,
  UsageQuestionnaireSMEComponent,
} from '@innogy/become-a-customer/usage-questionnaire';
import { OfferMailer } from '@innogy/offer-saver';
import {
  AnalyticsMapPipe,
  RoundedCurrencyPipe,
} from '@innogy/utils-deprecated';
import { provideBootstrapEffects } from '@innogy/utils-state';
import {
  NgbCarouselModule,
  NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    BecomeACustomerStateModule,
    HammerModule,
    NgbPopoverModule,
    AnalyticsDirectivesModule,
    NgbCarouselModule,
    UsageQuestionnaireSMEComponent,
    UsageQuestionnaireContainerComponent,
    OrderContainerComponent,
    BaseOrderOverviewComponent,
    OrderOverviewSmeComponent,
    VerticalOfferModalPlaceholderComponent,
    OfferBudgetbillSmeComponent,
    OfferBreakdownComponent,
    OfferBudgetbillComponent,
    OfferLabelComponent,
    OfferBreakdownRowComponent,
    OfferUspsComponent,
    OfferMoreInfoBlockComponent,
    EmailConsentsModalComponent,
    SelectCommodityPipe,
  ],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerGestureConfig,
    },
    RoundedCurrencyPipe,
    OfferMailer,
    provideBootstrapEffects([BacUsageQuestionnaireModalEffects]),
    AnalyticsMapPipe,
    CurrencyPipe,
  ],
})
export class BecomeACustomerBaseModule {}
